if (!customElements.get("year10-showcase")) {
  customElements.define(
    "year10-showcase",
    class Year10Showcase extends HTMLElement {
      constructor() {
        super();
        this.swiper = this.querySelector(".swiper");
      }

      connectedCallback() {
        this.initializeSwiper();
      }

      initializeSwiper() {
        const pagination = this.querySelector(".swiper-pagination");

        const swiperParams = {
          slidesPerView: 1,
          //   loop: true,
          pagination: {
            el: pagination,
            clickable: true,
          },
          breakpoints: {
            500: {
              slidesPerView: 2,
              spaceBetween: 25,
            },
          },
        };

        // 初始化 Swiper
        new Swiper(this.swiper, swiperParams);
      }
    }
  );
}
